import Vue from 'vue'
import {ClientTable} from 'vue-tables-2';




let options = {
    perPage: 10,
    pagination: { edge: false, nav: 'fixed', chunk: 10 },
    compileTemplates: true,
    filterByColumn: true,
    dateFormat: 'YYYY-MM-DD',
    datepickerOptions: {
      showDropdowns: true,
      autoUpdateInput: true,
    },
    texts: {
      filter: "Filtrar:",
      filterBy: 'Filtrar por {column}',
      noResults: "No se encontró información",
      count: '{count} Registros',
      loading: 'Cargando...',
      defaultOption: '',
      columns: 'Columnas',
      page:""
    },
  };
  let useVuex = false;
  let theme = "bootstrap4";
  let template = "default";
  
  Vue.use(ClientTable, options, useVuex, theme, template);
